// Test IDs for the home / landing feature.

export const HOME = {
	emergentLink: 'home-emergent-link',
	navLoginLink: 'home-nav-login-link',
	navLogoutBtn: 'home-nav-logout-btn',
	navAdminLink: 'home-nav-admin-link',
	navMyMeetingsLink: 'home-nav-my-meetings-link',
	navUserLabel: 'home-nav-user-label',
	titleInput: 'home-meeting-title-input',
	loginRequiredNotice: 'home-login-required-notice',
};
